import React, { Component } from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import './newYear.css'
import UserSelect from '../Controls/Users/UserSelect';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import SendIcon from '@mui/icons-material/Send'
import { HubConnectionBuilder } from '@aspnet/signalr';
import AuthStore from '../Auth/AuthStore';
import * as Scroll from 'react-scroll';
import { Link, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
var Snow = require('react-snow-effect');


/*
 * The Kanban React component
 */
export default class NewYearBoard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            messages: [],
            spLiders: []
        };

        this.loadMyGifts = this.loadMyGifts.bind(this);
        this.loadAvailableGifts = this.loadAvailableGifts.bind(this);
        this.handleVictimChange = this.handleVictimChange.bind(this);
        this.sendGift = this.sendGift.bind(this);
        this.loadSPLiders = this.loadSPLiders.bind(this);
        this.loadChat = this.loadChat.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.sendMessage = this.sendMessage.bind(this);

        const hubConnection = new HubConnectionBuilder()
            .withUrl("/hub")
            .build();

        var scope = this;

        hubConnection.on('newChatMessage', (senderId, message, isGift) => {

            if (senderId !== AuthStore.getUserId || isGift) {
                var messages = scope.state.messages;
                messages.push(message);
                scope.setState({ messages: messages }, () => {
                    if (scope.state.messages && scope.state.messages.length > 0) {
                        Scroll.scroller.scrollTo(scope.state.messages[scope.state.messages.length - 1].id, { "containerId": "scroll-container", smooth: false });
                    }
                });
            }
        });

        hubConnection.onclose((error) => { console.log('socket error'); console.log(error); hubConnection.start(); });

        hubConnection.start();
    }

    componentDidMount() {
        Events.scrollEvent.register('begin', function () {
            console.log("begin", arguments);
        });

        Events.scrollEvent.register('end', function () {
            console.log("end", arguments);
        });

        scrollSpy.update();

        this.loadMyGifts();
        this.loadAvailableGifts();
        this.loadChat();
        //this.loadSPLiders();
    }

    componentDidUpdate() {
        
    }

    sendMessage() {
        var messages = this.state.messages;

        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/NewYear/sendMessage', {
            method: 'POST',
            body: JSON.stringify({ Message: this.state.newMessage }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    messages.push(result);
                    scope.setState({ messages: messages, newMessage: '' }, () => {
                        if (scope.state.messages && scope.state.messages.length > 0) {
                            Scroll.scroller.scrollTo(scope.state.messages[scope.state.messages.length - 1].id, { "containerId": "scroll-container", smooth: false });
                        }
                    });
                }).catch((err) => console.log(err));
            }
        });
    }

    onSelectGift(gift) {
        if (this.state.selectedGift === gift) {
            this.setState({ selectedGift: null });
        }
        else {
            this.setState({ selectedGift: gift, giftCaption: gift.name });
        }
    }

    handleVictimChange(victim) {
        this.setState({ victim: victim});
    }

    randomDate() {
        return new Date(new Date().getTime() + Math.random() * 100000000000);
    }

    sendGift() {
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/NewYear/sendGift', {
            method: 'POST',
            body: JSON.stringify({ GiftId: this.state.selectedGift.id, VictimId: this.state.victim.id, Name: this.state.giftCaption  }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    scope.setState({ selectedGift: null, victim: null, "isMessage": true, "message": "Спасибо. Ваш подарок передан в доставку почтой России и будет доставлен " + scope.randomDate().toLocaleDateString() });
                    scope.loadSPLiders();
                }).catch((err) => console.log(err));
            }
        });
    }

    loadMyGifts() {
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/NewYear/myGifts', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    scope.setState({ myGifts: result});
                }).catch((err) => console.log(err));
            }
        });
    }

    loadChat() {
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/NewYear/messages', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    scope.setState({ messages: result }, () => {
                        if (scope.state.messages && scope.state.messages.length > 0) {
                            Scroll.scroller.scrollTo(scope.state.messages[scope.state.messages.length - 1].id, { "containerId": "scroll-container", smooth: false });
                        }
                    });
                }).catch((err) => console.log(err));
            }
        });
    }

    loadAvailableGifts() {
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/NewYear/availableGifts', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    scope.setState({ availableGifts: result });
                }).catch((err) => console.log(err));
            }
        });
    }

    loadSPLiders() {
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/NewYear/GetSpLiders', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    scope.setState({ spLiders: result });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleInputChange(e) {
        this.setState({ newMessage: e.target.value });
    }

    render() {
        return (
            <div className="new-year-board">
                <Snow/>

                {this.state.isMessage && <div className="globalMessage">{this.state.message}
                    <div className="globalMessage-button" onClick={() => this.setState({ isMessage: false})}>Ок :(</div>
                </div>}
                <div className="chat-block">
                    Новогодний чатик
                    <Element className="element chat-history-block" id="scroll-container" style={{
                        position: 'relative',
                        overflowY: 'scroll',
                    }}>
                        {this.state.messages && this.state.messages.map(m => (
                            <Element name={m.id}>
                                <div className="chat-message">
                                    {m.message}
                                </div>
                            </Element>
                        ))}
                    </Element>
                    <div className="write-message-block">
                        <FormControl>
                            <InputLabel htmlFor="tester-required">Мое сообщение</InputLabel>
                            <Input required
                                id="tester-required"
                                label="Мое сообщение"
                                fullWidth
                                multiline
                                margin="none"
                                value={this.state.newMessage}
                                onChange={this.handleInputChange}
                                autoComplete='off'
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton aria-label="send message" onClick={this.sendMessage} size="large">
                                            <SendIcon />
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                    </div>
                </div>

                <div className="new-year-my-gifts">
                    <div>
                        Мои подарки
                    </div>

                    <div className="my-gifts">
                        {this.state.myGifts && this.state.myGifts.length === 0 && <div>Ой, Вам никто ничего не подарил. Возможно Вас никто не любит</div>}
                        {this.state.myGifts && this.state.myGifts.length > 0 && <div className="my-gifts-list-wrapper">
                            <ImageList cols={2.5} className="gridList">
                                {this.state.myGifts.map(gift => (
                                    <ImageListItem key={gift.id}>
                                        <div className={'gift-image-' + gift.image} />
                                        <ImageListItemBar
                                            title={gift.giftName}
                                        />
                                    </ImageListItem>
                                ))}
                            </ImageList>
                           </div>}
                    </div>
                </div>

                <div className="new-year-send-gift">
                    <div>
                        Задарить подарок
                    </div>

                    <div className="my-gifts">
                        {this.state.availableGifts && this.state.availableGifts.length > 0 && <div className="available-gifts-list-wrapper">
                            <ImageList cols={3.5} className="gridList">
                                {this.state.availableGifts.map(gift => (
                                    <ImageListItem className={"selectable-gift " + (this.state.selectedGift === gift ? "selected-gift": "")} onClick={() => { this.onSelectGift(gift) }} key={gift.id}>
                                        <div className={'gift-image-' + gift.image} />
                                        <ImageListItemBar
                                            title={gift.name}
                                        />
                                    </ImageListItem>
                                ))}
                            </ImageList>
                        </div>}
                    </div>

                    {this.state.selectedGift && <div>
                        <div>Давай задарим <input onChange={(evt) => { this.setState({ "giftCaption": evt.target.value }) }} value={this.state.giftCaption} />!</div>
                        <div>
                            <div>Выбрать жертву: </div>
                            <div className="victim-select-wrapper"><UserSelect label="Жертва" name={this.state.victim} handleSelect={this.handleVictimChange} /></div>
                        </div>
                        {this.state.victim && <div className="send-gift-button" onClick={this.sendGift}>
                            Подарить
                        </div>}
                        
                    </div>}
                </div>
                
            </div>
        );
    }
}